import { useEffect } from 'react';
import { logger } from '../../utilities/logger';
import { webViewDispatcher } from '../../inter_op/native_dispatchers/web_view_dispatcher/web_view_dispatcher';
import { WebViewDispatcherAction } from '../../inter_op/native_dispatchers/web_view_dispatcher/web_view_dispatcher.constants';
import { AppState } from '../../contexts/app_state/app_state_context';
import { useAppState } from '../../contexts/app_state/use_app_state_context';
import { useMutation } from '@apollo/client';
import { graphql } from '../../gql/generated';
import { errorChecker } from '../../utilities/error_checker';

export const RESET_UNSEEN_POST_COUNT = graphql(`
  mutation ResetUnreadCount {
    resetUnseenPostCount
  }
`);

export const useResetBadgeCount = () => {
  const { status, isInitialised } = useAppState();
  const [resetUnseenPostCountMutation, { error }] = useMutation(RESET_UNSEEN_POST_COUNT, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });
  if (error) {
    logger.error({
      error: errorChecker(error),
      message: 'Error resetting unseen post count',
    });
  }
  useEffect(() => {
    const resetBadgeCount = async () => {
      logger.debug({
        message: 'Try to reset the badge count',
      });
      await resetUnseenPostCountMutation();
      webViewDispatcher.postMessage({
        action: WebViewDispatcherAction.setBadgeCount,
        payload: { count: 0 },
      });
    };
    if (status === AppState.active && isInitialised) {
      resetBadgeCount();
    }
  }, [status, isInitialised, resetUnseenPostCountMutation]);
};
